module.exports = __webpack_public_path__ + "fd330d380a0c2e5aa2ac5da54d986531.svg";